import { Box, Button, Flex, Heading, Image, Text, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import LandingCardGrill from '../../V2/Assets/Icons/LandingCardGrill.svg';
import Group from '../../V2/Assets/Icons/Group.svg';
import { Link as RouterLink } from 'react-router-dom';
import { sendTrackingEvent } from '../../../utils/gtm';

const KnowYourLevelLanding = ({ data }: { data: { text: string; description: string } }) => {
	const text = data?.text || 'Know Your Level';
	const isLargeScreen = useBreakpointValue({ base: false, md: true });
	return (
		<Flex
			isolation="isolate"
			p={['32px 16px 20px 16px', '32px 16px 20px 16px', '58px 80px 39px 80px']}
			align={['center', 'center']}
			justify={['center', 'center']}
		>
			<Flex
				bg="#D6E2FA"
				w={['100%', '1280px']}
				// h={['608px', '321px']}
				py="16px"
				borderRadius="40px"
				overflow="hidden"
				backgroundImage={LandingCardGrill}
				position="relative"
				flexDirection={['column-reverse', 'column-reverse', 'column-reverse', 'row']}
			>
				<Box
					w="392px"
					h="392px"
					borderRadius="392px"
					bg="#5D8DE9"
					position="absolute"
					top={{ base: '325px', md: '-150px' }}
					left={{ base: '-25px', md: '-50px' }}
					right={{ base: '0px', md: 'auto' }}
					mx="auto"
					zIndex="0"
				></Box>
				<Box
					px="16px"
					display="flex"
					flexDir={{ base: 'column-reverse', md: 'row' }}
					gap="16px"
					alignItems="center"
					justifyContent="space-between"
					w="full"
				>
					<Image
						w={['259.01px', '285.694px']}
						h={['262.01px', '289.068px']}
						position={'relative'}
						// top={['330px', '25px']}
						// left={['0px', '60px']}
						// right={['0px', '950px']}
						mx={'auto'}
						src={Group}
						zIndex={2}
					/>
					<Flex
						flexDirection="column"
						alignItems={['center', 'flex-start', 'flex-start']}
						justify={['center', 'left', 'left']}
						gap="24px"
						// position="absolute"
						top={['10px', '30px']}
						left={['0px', '460px']}
						p={['0px', 'auto']}
						right="0px"
						mx="auto"
						textAlign={{ base: 'center', md: 'left' }}
					>
						<Flex flexDirection="column" gap="12px">
							{isLargeScreen ? (
								<Heading as="h1" color="#4358F6" textAlign={{ base: 'center', md: 'left' }} zIndex={1}>
									{text.split(' ').map((word, index) => (
										<span key={index}>
											<span style={{ fontSize: '64px' }}>{word.charAt(0)}</span>
											{word.slice(1)}
											{index < text.split(' ').length - 1 && ' '}
										</span>
									))}
								</Heading>
							) : (
								<Heading as="h1" color="#4358F6" textAlign={{ base: 'center', md: 'left' }} zIndex={['1', '0']}>
									{text}
								</Heading>
							)}
							<Text textStyle={['body1-md', 'subtitle2']} textAlign={{ base: 'center', md: 'left' }} zIndex={'1'}>
								{data?.description}
							</Text>
						</Flex>
						{/* <Text textStyle="subtitle2" display="inline-block" zIndex={'1'}>
							Test Date:{' '}
							<Text textStyle={['h3', 'h2']} display="inline">
								16th August
							</Text>
						</Text> */}
						<Button
							mx={{ base: 'auto', md: '0px' }}
							variant="primary"
							bg="#4358F6"
							color="#FFFFFF"
							p="12px 20px"
							w="full"
							maxW={['100%', '385px']}
							zIndex={'1'}
							size="lg"
							as={RouterLink}
							to="/sign-in"
							onClick={() => {
								sendTrackingEvent({
									event: 'cn_start_learnigng3',
									eventLabel: window.location.href,
								});
							}}
						>
							Start Learning
						</Button>
					</Flex>
				</Box>

				<Box
					h={{ base: '150px', md: '290px' }}
					w={{ base: '150px', md: '290px' }}
					bg="#85A9EF"
					borderRadius="290px"
					position="absolute"
					// bottom={['500px', '-130px']}
					// right={['-60px', '-100px']}
					top={{ base: '-40px', md: 'auto' }}
					bottom={{ base: 'auto', md: '-150px' }}
					right={{ base: '-50px', md: '-110px' }}
					zIndex="0"
				></Box>
			</Flex>
		</Flex>
	);
};

export default KnowYourLevelLanding;
